import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-sales-progress',
  templateUrl: './skeleton-sales-progress.component.html',
  styleUrls: ['./skeleton-sales-progress.component.scss']
})
export class SkeletonSalesProgressComponent implements OnInit {
  readonly itemsSkeleton = [1, 2];
  @Input() userType!: string; 
  constructor() { }

  ngOnInit() {
  }

}
